import { render, staticRenderFns } from "./surrender.vue?vue&type=template&id=0960d755&scoped=true&"
import script from "./surrender.vue?vue&type=script&lang=js&"
export * from "./surrender.vue?vue&type=script&lang=js&"
import style0 from "./surrender.vue?vue&type=style&index=0&id=0960d755&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0960d755",
  null
  
)

export default component.exports